import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import Chevron from '../../../components/Chevron'
import { Direction } from '../../../utils/constants'
import { twMerge } from 'tailwind-merge'
import { FormattedMessage } from 'react-intl'
import SummaryPicture from '../../ContentGrid/SummaryPicture'

export interface AccordionItemData {
  id: string
  slug?: string
}

interface AccordionItemProps {
  item: AccordionItemData
  activeItem: number
  setActiveItem: () => void
  timeout?: number
  index: number
  onClose: (e: any) => void
}

const AccordionItem = ({
    item,
    activeItem,
    setActiveItem,
    timeout,
    index,
    onClose,
}: AccordionItemProps) => {
    const ref = useRef<HTMLDivElement>(null)
    const [height, setHeight] = useState(0)
    const [isActive, setIsActive] = useState(false)

    useEffect(() => {
        setIsActive(activeItem === index)
    }, [activeItem, index])

    useLayoutEffect(() => {
        const calculateHeight = () => {
            if (ref.current) {
                setHeight(ref.current.getBoundingClientRect().height ?? 0)
            }
        }
        calculateHeight()
        window.addEventListener('resize', calculateHeight)
        return () => {
            window.removeEventListener('resize', calculateHeight)
        }
    }, [ref])

    return (
        <div
            className={twMerge(
                'flex flex-col w-full  cursor-pointer relative',
                isActive ? 'text-black pt-5' : 'text-black/50 py-5 border-b border-black/10 ',
            )}
            onClick={setActiveItem}
        >
            <div className='flex justify-between'>
                <FormattedMessage id={item.id} tagName='h5' />
                <button onClick={isActive ? onClose : undefined}>
                    <Chevron
                        direction={isActive ? Direction.UP : Direction.DOWN}
                        className='w-5 stroke-black'
                    />
                </button>
            </div>
            <div
                style={{
                    height: isActive ? height : 0,
                    margin: isActive ? '20px 0' : '0px 0',
                    opacity: isActive ? 1 : 0,
                }}
                className={
                    isActive ? 'transition--accordion-item-enter' : 'transition--accordion-item-exit'
                }
            >
                <div ref={ref}>
                    <FormattedMessage id={`${item.id}.description`}>
                        {(value) => (
                            <p
                                className='text-[14px] h-[152px]'
                                dangerouslySetInnerHTML={{ __html: value.toString() }}
                            ></p>
                        )}
                    </FormattedMessage>
                    <SummaryPicture
                        slug={item.slug || item.id}
                        imageClassName='w-full p-[5%]'
                        className='aspect-square md:hidden p-0 pt-8'
                    />
                </div>
            </div>
            <div className='absolute h-px bottom-0 w-full bg-black/10'>
                <div
                    style={{ transitionDuration: `${isActive ? timeout : 0}ms` }}
                    className={twMerge(
                        'bg-black h-full hidden md:block',
                        isActive ? 'transition-width ease-linear md:w-full' : 'w-0',
                    )}
                />
            </div>
        </div>
    )
}

export default AccordionItem
